import { JobProgress } from "../JobProgress";
import type { SafeProjectDraft } from "../../../lib/api";
import { Button } from "../../../components/ui/Controls";
import { AlertBanner, StatusBadge } from "../../../components/ui/Feedback";

export function WizardReview({
  busy,
  draft,
  error,
  onApply,
}: {
  readonly busy: boolean;
  readonly draft: SafeProjectDraft;
  readonly error?: string;
  readonly onApply: () => void;
}) {
  const config = draft.effectiveConfig;
  return (
    <section aria-labelledby="wizard-review-heading" className="card stack">
      <div className="split-row">
        <div>
          <p className="eyebrow">Sunucu incelemesi</p>
          <h2 id="wizard-review-heading">Etkili güvenli yapılandırma</h2>
        </div>
        <StatusBadge status={draft.status === "applied" ? "queued" : "checking"} />
      </div>
      <p>
        Tarayıcı bu ayarları uygulamaz. Sunucu bu taslak sürümünü tekrar doğrular ve yalnızca kabul
        edilmiş iş sonucu bir değişiklik anlamına gelir.
      </p>
      <dl className="definition-grid">
        <div>
          <dt>Taslak sürümü</dt>
          <dd>{draft.revision}</dd>
        </div>
        <div>
          <dt>Framework</dt>
          <dd>{frameworkLabel(config.framework)}</dd>
        </div>
        <div>
          <dt>Çalışma zamanı</dt>
          <dd>{config.runtime === "docker" ? "İzole Docker" : "Güvenilen yerel çalışma zamanı"}</dd>
        </div>
        <div>
          <dt>CPU / bellek / disk</dt>
          <dd>
            {config.limits.cpuMillicores} mCPU · {config.limits.memoryMiB} MiB ·{" "}
            {config.limits.diskMiB} MiB
          </dd>
        </div>
        <div>
          <dt>Ağ çıkışı</dt>
          <dd>Engelli</dd>
        </div>
        <div>
          <dt>Sağlık denetimi</dt>
          <dd>
            <code>{config.healthPath}</code>
          </dd>
        </div>
        <div>
          <dt>Gizli değer adları</dt>
          <dd>
            {config.environmentNames.length === 0 ? "Yok" : config.environmentNames.join(", ")}
          </dd>
        </div>
      </dl>
      {error === undefined ? null : (
        <AlertBanner heading="Taslak uygulanamadı" tone="error">
          <p>{error}</p>
        </AlertBanner>
      )}
      {draft.status === "draft" ? (
        <Button busy={busy} busyLabel="Sunucu taslağı uygulanıyor…" onClick={onApply}>
          Taslağı uygula
        </Button>
      ) : null}
      {draft.job === undefined ? null : <JobProgress jobId={draft.job.id} />}
    </section>
  );
}

function frameworkLabel(value: SafeProjectDraft["effectiveConfig"]["framework"]): string {
  if (value === "nextjs") return "Next.js";
  if (value === "static") return "Statik site";
  return "Node.js";
}
